import * as angular from 'angular';
import { ErrorHandler } from 'app/_services/error-handler.factory';

class NetworkPointDetailsAuctionsCtrl implements ng.IController {
    public onAuctionPromiseResolved: (parameter: {
        shortTermAuctions: AuctionShortTermDto[];
        longTermAuctions: AuctionLongTermDto[];
    }) => void;
    public networkPointId: number;
    public uiLoadingContracts: boolean = true;
    public LONG_TERM_AUCTIONS = ['MONTH', 'QUARTER', 'YEAR', 'REST_OF_YEAR'];
    public SHORT_TERM_AUCTIONS = ['DAY', 'WITHINDAY'];
    public uiLoading: any = {
        longTerms: true,
        shortTerms: true
    };
    public auctions: any = {
        shortTerms: {
            auctions: [],
            totalSize: 0
        },
        longTerms: {
            auctions: [],
            totalSize: 0
        }
    };
    public paginator: any = {
        shortTerms: {
            identificationName: 'shortTerms',
            itemsPerPage: 10,
            start: 0
        },
        longTerms: {
            identificationName: 'longTerms',
            itemsPerPage: 10,
            start: 0
        }
    };

    constructor(
        private auctionResource,
        private $location,
        private errorHandler: ErrorHandler,
        private $q: ng.IQService
    ) {}

    $onInit(): void {
        let longTermPromise = this.getAuctionsLongTerm();
        let shortTermPromise = this.getAuctionsShortTerm();

        if (!this.onAuctionPromiseResolved) {
            return;
        }
        this.$q.all([longTermPromise, shortTermPromise]).then(() => {
            this.onAuctionPromiseResolved({
                shortTermAuctions: this.auctions.shortTerms.auctions,
                longTermAuctions: this.auctions.longTerms.auctions
            });
        });
    }

    public getAuctionsLongTerm() {
        return this.fetchAuctions(
            'longTerms',
            this.paginator.longTerms,
            this.LONG_TERM_AUCTIONS,
            ['PUBLISHED', 'OPEN', 'CLOSED']
        );
    }

    public getAuctionsShortTerm() {
        return this.fetchAuctions(
            'shortTerms',
            this.paginator.shortTerms,
            this.SHORT_TERM_AUCTIONS,
            ['OPEN']
        );
    }

    public fetchAuctions(type, paginator, periodTypes, phase) {
        this.uiLoading[type] = true;
        return this.auctionResource.query(
            {
                networkPoint: this.networkPointId,
                pageSize: paginator.itemsPerPage,
                periodType: periodTypes,
                start: paginator.start,
                phase: phase,
                runtimeFrom: moment().toISOString(),
                runtimeTo: moment().add(20, 'years').toISOString()
            },
            (res) => {
                this.auctions[type].auctions = res.data;
                this.auctions[type].totalSize = res.totalSize;
                this.paginator[type].start = res.start;
                this.uiLoading[type] = false;
            },
            this.errorHandler
        ).$promise;
    }

    public changePage(newPageNumber, identificationNameOfTable) {
        switch (identificationNameOfTable) {
            case this.paginator.longTerms.identificationName: {
                this.paginator.start =
                    (newPageNumber - 1) * this.paginator.longTerms.itemsPerPage;
                if (this.paginator.start !== this.paginator.longTerms.start) {
                    this.paginator.longTerms.start = this.paginator.start;
                    this.getAuctionsLongTerm();
                }
                break;
            }
            case this.paginator.shortTerms.identificationName: {
                this.paginator.start =
                    (newPageNumber - 1) *
                    this.paginator.shortTerms.itemsPerPage;
                if (this.paginator.start !== this.paginator.shortTerms.start) {
                    this.paginator.shortTerms.start = this.paginator.start;
                    this.getAuctionsShortTerm();
                }
                break;
            }
        }
    }
}

angular.module('app').component('pkpNetworkPointDetailsAuctions', {
    controller: NetworkPointDetailsAuctionsCtrl,
    template:
        require('app/network-point/network-point-details-auctions.component.html'),
    bindings: {
        networkPointId: '<',
        onAuctionPromiseResolved: '&?'
    }
});
